import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class HealthApi {
  static getApiVersion(): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'GET',
      url: `${BASE_URL}/health/apiversion`,
    });
  }
}
